function HandleModalImageModals()
{
  var triggers = document.querySelectorAll( ".product_card--image-modal-trigger" );
  if( triggers && triggers.length > 0 )
  {
    triggers.forEach( function( trigger )
    {
      trigger.addEventListener( "click", function()
      {
        var parent = trigger.closest( ".product_card--image_wrapper" );
        var container  = parent.querySelector( ".product_card--image-modal-wrapper" );
        var modalID = container.dataset.productId;
        var modal = container.querySelector( ".product_card--image-modal")
        var images = container.querySelectorAll( "img" );
        images.forEach( function( img )
        {
          if( img.hasAttribute( "src" ) == false )
          {
            img.setAttribute( "src", img.getAttribute( "data-src" ) );
          }
        });
        modal.swiper = new Swiper( "[data-product-id='" + modalID + "'] .product_card--image-modal", {
          slidesPerGroup: 1,
          slidesPerView: 1,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        });
        container.classList.add( "active" );
      });
    });
  }
  var closeModals = document.querySelectorAll( ".product_card--image-modal-close" );
  if( closeModals && closeModals.length > 0 )
  {
    closeModals.forEach( function( close )
    {
      close.addEventListener( "click", function()
      {
        var modal = close.closest( ".product_card--image-modal-wrapper" );
        if( modal.classList.contains( "active" ) )
        {
          modal.classList.remove( "active" );
        }
      });
    });
  }
}

window.addEventListener( "resize", function( e )
{
    var filterGrid = document.getElementById('filterGridContainer');
    var openFilterBtn = document.getElementById('openFilter');
    if( window.innerWidth <= "768" )
    {
        openFilterBtn.innerHTML = "Filter Products";
        filterGrid.classList.add('filter-grid-container--filter-hidden');        
    }
    else
    {
        openFilterBtn.innerHTML = "Hide Filters";
        filterGrid.classList.remove('filter-grid-container--filter-hidden');        
    }
} );

document.addEventListener('DOMContentLoaded', () => {

    // Handle mobile image modals
    HandleModalImageModals();

    //Open Filter Modal
    const openFilterBtn = document.getElementById('openFilter');
    const openFilterBtn_mobile = document.getElementById('openFilterMobile');
    const clearBtn = document.querySelector('.filter__button--clear');

    const modalBdrop = document.querySelector('.filter__modal--backdrop');
    const modal = document.querySelector('.filter__modal');
    const body = document.querySelector('body');
    // //Open Filter Modal
    // openFilterBtn.addEventListener('click', () => {
    //   event.preventDefault();
    //   modalBdrop.classList.remove('hidden');
    //   modal.classList.remove('hidden');
    //   body.style.overflow = 'hidden';
    // })
    // //Open Filter Modal Mobile
    // openFilterBtn_mobile.addEventListener('click', () => {
    //   event.preventDefault();
    //   modalBdrop.classList.remove('hidden');
    //   modal.classList.remove('hidden');
    //   body.style.overflow = 'hidden';
    // })

    //Open/Close Fixed Filter
    openFilterBtn.addEventListener('click', () => {
      event.preventDefault();
      console.log('click');
      var el = document.getElementById('filterGridContainer');
      el.classList.toggle('filter-grid-container--filter-hidden');

      if (openFilterBtn.innerHTML === "Filter Products") {
        openFilterBtn.innerHTML = "Hide Filters";
      } else {
        openFilterBtn.innerHTML = "Filter Products";
      }
    });

    // Collection filter Media Query condition
    var mediaQuery = window.matchMedia('(min-width: 768px)')
    var filterGrid = document.getElementById('filterGridContainer');
    if (mediaQuery.matches) {
      openFilterBtn.innerHTML = "Hide Filters";
      filterGrid.classList.remove('filter-grid-container--filter-hidden');
    } else {
      openFilterBtn.innerHTML = "Filter Products";
      filterGrid.classList.add('filter-grid-container--filter-hidden');
    }

    // Clear filters btn
    clearBtn.addEventListener('click', (e) => {
        event.preventDefault();
        window.location = e.target.dataset.url;
    })

    //Open Sort Modal on mobile
    const openSortBtn = document.querySelector('#openSort');
    const sortModal = document.querySelector('.sort__modal');
    const sortModalBdrop = document.querySelector('.sort__modal--backdrop');

    openSortBtn.addEventListener('click', () => {
      event.preventDefault();
      sortModal.classList.remove('hidden');
      sortModalBdrop.classList.remove('hidden');
      body.style.overflow = 'hidden';
    })


    //Update Sort_by url
    const sortBy = document.getElementById('SortBy');
    sortBy.addEventListener('change', () => {
      // const sortByUrl = '{{collection.url}}' + '?sort_by=' + sortBy.value;
      const sortByUrl = '?sort_by=' + sortBy.value;
      window.location.replace(sortByUrl);
    })

    var variantSelectors = document.querySelectorAll( ".product-variant-quantity-container .product__variant--dropdown" );
    if( variantSelectors && variantSelectors.length > 0 )
    {
      variantSelectors.forEach( function( selector )
      {
        selector.addEventListener( "change", function( e )
        {
          var productGridItem = selector.closest( ".product-grid__item" );
          var selectedOption = selector.options[selector.selectedIndex];
          var productOnetimePrice = productGridItem.querySelector( ".option__onetime .option--price" );
          var productSubscriptionPrice = productGridItem.querySelector( ".option__subSave .option--price" );
          var formWrapper = e.currentTarget.closest( ".product_card--content_wrapper" );
          if( formWrapper.dataset.automaticDiscount )
          {
            var widget = formWrapper.querySelector( ".rc-container-wrapper" );
            var availableVariant = selectedOption;
            var discount = Number( formWrapper.dataset.automaticDiscount );
            var onetimePrice = Number( availableVariant.dataset.originalprice );
            var subsavePrice = Number( availableVariant.dataset.price );
            var currencySymbol = formWrapper.dataset.currency;
    
            var subsaveContainer = widget.querySelector( ".option__subSave .option--price" );
            var onetimeContainer = widget.querySelector( ".option__onetime .option--price" );
    
            var subsaveDiscount_price = ( ( subsavePrice / 100 ) - ( ( subsavePrice / 10000 ) * discount ) ).toFixed( 2 );
            var onetimeDiscount_price = ( ( onetimePrice / 100 ) - ( ( onetimePrice / 10000 ) * discount ) ).toFixed( 2 );
    
            subsaveContainer.innerHTML = `<span class="discount-price-subsave">${currencySymbol}${subsaveDiscount_price}</span><span class="discount-price-strikethrough">${currencySymbol}${( subsavePrice / 100 ).toFixed( 2 )}</span>`;
            onetimeContainer.innerHTML = `<span class="discount-price-onetime">${currencySymbol}${onetimeDiscount_price}</span><span class="discount-price-strikethrough">${currencySymbol}${( onetimePrice / 100 ).toFixed( 2 )}</span>`;
          }
          else
          {
            if( productOnetimePrice )
              {
                productOnetimePrice.innerText = theme.Currency.formatMoney( selectedOption.dataset.originalprice, theme.settings.moneyFormat );
              }
              if( productSubscriptionPrice )
              {
                productSubscriptionPrice.innerHTML = theme.Currency.formatMoney( selectedOption.dataset.price, theme.settings.moneyFormat ) + '<span class="option--price option--price-original">' + theme.Currency.formatMoney( selectedOption.dataset.originalprice, theme.settings.moneyFormat ) + '</span>';
              }
          }
        });
      });
    }
  });